export const PUBLIC_CREATOR_ROUTE_PREFIXES = [
  "/@",
  "/s@",
  "/%40",
  "/s%40",
] as const;
